import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { Page } from '../page.model';
import { Organization, OrganizationDetail, OrganizationPayload } from './organization.models';

export interface OrganizationFilters {
  q?: string | null;
  page?: number;
  size?: number;
}

@Injectable({ providedIn: 'root' })
export class OrganizationService {
  private readonly http = inject(HttpClient);
  private readonly auth = inject(AuthService);

  private base(): string {
    return `/api/t/${this.auth.currentTenant()}/organizacoes`;
  }

  list(filters: OrganizationFilters = {}): Observable<Page<Organization>> {
    let params = new HttpParams();
    for (const [key, value] of Object.entries(filters)) {
      if (value !== null && value !== undefined && value !== '') {
        params = params.set(key, String(value));
      }
    }
    return this.http.get<Page<Organization>>(this.base(), { params });
  }

  get(id: number): Observable<OrganizationDetail> {
    return this.http.get<OrganizationDetail>(`${this.base()}/${id}`);
  }

  create(payload: OrganizationPayload): Observable<Organization> {
    return this.http.post<Organization>(this.base(), payload);
  }

  update(id: number, payload: OrganizationPayload): Observable<Organization> {
    return this.http.put<Organization>(`${this.base()}/${id}`, payload);
  }

  uploadLogo(id: number, file: File): Observable<Organization> {
    const form = new FormData();
    form.append('file', file);
    return this.http.post<Organization>(`${this.base()}/${id}/logo`, form);
  }
}
